import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-video.mjs";
import { render } from "lit-html";
import { loadYouTube } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import Strings from "../../../models/Strings.json";
import Training1 from "../../../models/Training1.json";
import Training2 from "../../../models/Training2.json";

const strings: any = Strings;
const training1: any = Training1;
const training2: any = Training2;

export class HbVideo extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;

    private video: HTMLElement;
    private name: HTMLHeadingElement; // cannot use title: reserved word
    private youtube: HTMLIFrameElement;
    private step: HTMLHeadingElement;
    private description: HTMLParagraphElement;
    private done: HTMLButtonElement;

    constructor() {
        super();
        render(template(null), this);

        this.video = this.querySelector("#hb-video")!;
        this.name = this.querySelector("#hb-video-title")!;
        this.youtube = this.querySelector("#hb-video-youtube")!;
        this.step = this.querySelector("#hb-video-step")!;
        this.description = this.querySelector("#hb-video-description")!;
        this.done = this.querySelector("#hb-video-done")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                // window.location.hash =
                //     "#/onboard/training-" + (this.heartbank.user ? "2" : "1");
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-video",
            override: true
        };

        this.modal = new Modal(this.video, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.done.addEventListener("click", () => {
            window.location.hash = "#/onboard/training-2";
        });
    }

    show(page: string) {
        const numbers = page.split("-");
        const trainingNumber = parseInt(numbers[1]);
        const index = parseInt(numbers[2]) - 1;
        this.render(
            trainingNumber,
            index + 1,
            trainingNumber === 1 ? training1[index] : training2[index]
        );
        loadYouTube(this);
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private render(trainingNumber: number, taskNumber: number, task: any) {
        this.name.textContent = `${taskNumber}. ${task.title}`;
        this.youtube.dataset.src = task.url;
        this.youtube.title = task.title;
        this.step.textContent = `Training ${trainingNumber}: Step ${taskNumber}`;
        this.description.innerHTML = task.description;
    }
}
